import api from "src/apis/api"

// ── Bookings ─────────────────────────────────────────────────────────────────
export async function fetchBookings({ page = 1, per_page = 20, status = "", project_id = "", q = "" } = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)
  if (status)     params.set("status", status)
  if (project_id) params.set("project_id", project_id)
  if (q)          params.set("q", q)

  const { data } = await api.get(`/api/v1/bookings?${params}`)
  return data
}

export async function fetchBooking(id) {
  const { data } = await api.get(`/api/v1/bookings/${id}`)
  return data.booking
}

// Create a booking from a won deal + a chosen unit.
export async function createBooking(payload) {
  const { data } = await api.post("/api/v1/bookings", { booking: payload })
  return data.booking
}

// Edit the customer contact fields (name / phone / email) on a booking.
export async function updateBookingCustomer(id, customer) {
  const { data } = await api.patch(`/api/v1/bookings/${id}`, { booking: customer })
  return data.booking
}

export async function cancelBooking(id, reason) {
  const { data } = await api.post(`/api/v1/bookings/${id}/cancel`, { reason })
  return data.booking
}

export async function completeBooking(id) {
  const { data } = await api.post(`/api/v1/bookings/${id}/complete`)
  return data.booking
}

export async function recordPayment(id, payload) {
  const { data } = await api.post(`/api/v1/bookings/${id}/record_payment`, payload)
  return data.booking
}

export async function provisionCustomer(id) {
  const { data } = await api.post(`/api/v1/bookings/${id}/provision_customer`)
  return data.booking
}

export async function sendEmailVerification(id) {
  const { data } = await api.post(`/api/v1/bookings/${id}/send_email_verification`)
  return data.booking
}

// (Re)generate the branded booking-confirmation letter from the current
// template + booking data. Returns the saved Document.
export async function generateBookingConfirmation(id) {
  const { data } = await api.post(`/api/v1/bookings/${id}/booking_confirmation`)
  return data.document
}

// Public: confirm a customer email from the emailed token link.
export async function verifyCustomerEmail(token) {
  const { data } = await api.patch(`/api/v1/customer_email_verifications/${token}`)
  return data
}

// Units available for booking, scoped to a project.
export async function fetchAvailableUnits(projectId) {
  const { data } = await api.get(`/api/v1/projects/${projectId}/units?status=available`)
  return data.units || []
}
